import {Injectable} from '@angular/core';
import {rowDataObject} from './grid-data';


@Injectable()
export class DataService {


  right_side_view = {
    dataset: 'rowData1'
  };
  left_side_view = {
    dataset: 'rowData1'
  };

    constructor() {}

    getData(dataSet: string, gridId: string): any[] {
      this[gridId].dataset = dataSet;
      return rowDataObject[dataSet];
    }
    syncData(gridId: string, oppositeGridId: string): any[] {
      const newDataSet = this[oppositeGridId].dataset;
      this[gridId].dataset = newDataSet;
      return rowDataObject[newDataSet];
    }

}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/data/data.service.ts